import { render } from "./LoadingScreen.vue?vue&type=template&id=5ffca7bb"
import script from "./LoadingScreen.vue?vue&type=script&lang=js"
export * from "./LoadingScreen.vue?vue&type=script&lang=js"

import "./LoadingScreen.vue?vue&type=style&index=0&id=5ffca7bb&lang=css"
script.render = render

export default script